declare var process: any;
declare global {
    interface Window {
        VF: any;
        vf: any;
        Cypress: any;
        CXBus: any;
        _genesys: any;
        _gt: any;
    }
}

let environment = process.env.NODE_ENV;

if (window.VF.enterpriseEnvironment) {
    environment = window.VF.enterpriseEnvironment;
}

if (
    location.hostname === "int108.vodafone.de" ||
    location.hostname.includes("dev.vf-eo.de")
) {
    environment = "int108";
} else if (location.hostname === "eweb8.vfd2-testnet.de") {
    environment = "eweb8";
}

let config;

if (environment === "production") {
    config = {
        API_DATA_PATH: "",
        CHECKOUT_ENDPOINT: "/api/vfd2dyn/json/enterprise-nsf-checkout/",
        BANKACCOUNT_ENDPOINT: "/api/commerce/bankaccount",
        VOUCHER_CODE_ENDPOINT:
            "/api/vfd2dyn/json/enterprise-nsf-checkout/vouchercodes/",
        CHECKOUT_SUCCESS_URL: "/business/shop/bestellen-success.html",
        CHECKOUT_UPLOAD_URL: "/business/shop/bestellen-upload.html",
        BASKET_PAGE_URL: "/business/shop/warenkorb.html",
        CHECKOUT_PAGE_URL: "/business/shop/checkout.html",
        ESHOP_JSON_URL: "/business/shop/eshop.json",
        ESHOP_VERSION_URL: "/business/shop/eshop.version.json",
        BID2VOID_URL: "/business/shop/bid2void.json",
        CBU_BASKET_URL: "/shop/warenkorb.html#/basket/",
        CBU_BASKET_ENDPOINT: "/api/commerce/basket",
        EECC_SERVICE: "/api/vfd2dyn/pdf/enterprise-nsf-checkout/eecc/",
        EECC_ACTIVE: true,
        CBU_CHECKOUT_TARIFF_IDS: [137],
        VOUCHER_DISCOUNT_ID: 166,
    };
} else if (environment === "int108") {
    config = {
        TEALIUM_ENVIRONMENT: "autotest",
        API_DATA_PATH: "",
        CHECKOUT_ENDPOINT: "/api/vfd2dyn_s/json/enterprise-nsf-checkout/",
        BANKACCOUNT_ENDPOINT: "/api/commerce/bankaccount",
        VOUCHER_CODE_ENDPOINT:
            "/api/vfd2dyn_s/json/enterprise-nsf-checkout/vouchercodes/",
        CHECKOUT_SUCCESS_URL: "/business/shop/bestellen-success.html",
        CHECKOUT_UPLOAD_URL: "/business/shop/bestellen-upload.html",
        BASKET_PAGE_URL: "/business/shop/warenkorb.html",
        CHECKOUT_PAGE_URL: "/business/shop/checkout.html",
        ESHOP_JSON_URL: "/business/shop/eshop.json",
        ESHOP_VERSION_URL: "/business/shop/eshop.version.json",
        BID2VOID_URL: "/business/shop/bid2void.json",
        CBU_BASKET_URL: "/shop/warenkorb.html#/basket/",
        CBU_BASKET_ENDPOINT: "/api/commerce/basket",
        EECC_SERVICE: "/api/vfd2dyn_s/pdf/enterprise-nsf-checkout/eecc/",
        EECC_ACTIVE: true,
        CBU_CHECKOUT_TARIFF_IDS: [137],
        VOUCHER_DISCOUNT_ID: 166,
    };
} else if (environment === "eweb8") {
    config = {
        TEALIUM_ENVIRONMENT: "autotest",
        API_DATA_PATH: "",
        CHECKOUT_ENDPOINT: "/api/vfd2dyn_s/json/enterprise-nsf-checkout/",
        BANKACCOUNT_ENDPOINT: "/api/commerce/bankaccount",
        VOUCHER_CODE_ENDPOINT:
            "/api/vfd2dyn_s/json/enterprise-nsf-checkout/vouchercodes/",
        CHECKOUT_SUCCESS_URL: "/business/shop/bestellen-success.html",
        CHECKOUT_UPLOAD_URL: "/business/shop/bestellen-upload.html",
        BASKET_PAGE_URL: "/business/shop/warenkorb.html",
        CHECKOUT_PAGE_URL: "/business/shop/checkout.html",
        ESHOP_JSON_URL: "/business/shop/eshop.json",
        ESHOP_VERSION_URL: "/business/shop/eshop.version.json",
        BID2VOID_URL: "/business/shop/bid2void.json",
        CBU_BASKET_URL: "/shop/warenkorb.html#/basket/",
        CBU_BASKET_ENDPOINT: "/api/commerce/basket",
        EECC_SERVICE: "/api/vfd2dyn_s/pdf/enterprise-nsf-checkout/eecc/",
        EECC_ACTIVE: true,
        CBU_CHECKOUT_TARIFF_IDS: [137],
        VOUCHER_DISCOUNT_ID: 166,
    };
} else {
    config = {
        TEALIUM_ENVIRONMENT: "autotest",
        API_DATA_PATH: "/simplicity/api-static/enterprise",
        CHECKOUT_ENDPOINT:
            "https://dyn-stage.vodafone.de/api-www/enterprise-nsf-checkout/",
        BANKACCOUNT_ENDPOINT: "/api/commerce/bankaccount",
        VOUCHER_CODE_ENDPOINT:
            "https://dyn-stage.vodafone.de/api-www/enterprise-nsf-checkout/vouchercodes/",
        CHECKOUT_SUCCESS_URL:
            "/simplicity/bundles/enterprise-shop/bestellen-success.html",
        CHECKOUT_UPLOAD_URL: "/business/shop/bestellen-upload.html",
        BASKET_PAGE_URL: "/simplicity/bundles/enterprise-shop/warenkorb.html",
        CHECKOUT_PAGE_URL: "/simplicity/bundles/enterprise-shop/checkout.html",
        ESHOP_JSON_URL: "/cache/eshop.json",
        ESHOP_VERSION_URL: "/cache/eshop.version.json",
        BID2VOID_URL: "/vlux/misc/bid2void.json",
        CBU_BASKET_URL: "/shop/warenkorb.html#/basket/",
        CBU_BASKET_ENDPOINT: "/api/commerce/basket",
        EECC_SERVICE:
            "https://dyn-stage.vodafone.de/api-www/enterprise-nsf-checkout/eecc/",
        EECC_ACTIVE: true,
        CBU_CHECKOUT_TARIFF_IDS: [137],
        VOUCHER_DISCOUNT_ID: 166,
    };
}

export default config;



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/config.ts